export default "__VITE_ASSET__BQIEQqL4__"